// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2vnxe","requiredAsterisk":"Info_requiredAsterisk__37Mgy"};